// extracted by mini-css-extract-plugin
export var astrazeneca = "TrustedBy-module--astrazeneca--yLmZn";
export var bms = "TrustedBy-module--bms--g9oe3";
export var highPerformer = "TrustedBy-module--highPerformer--W0akY";
export var institutionContainer = "TrustedBy-module--institutionContainer--kKmDn";
export var institutions = "TrustedBy-module--institutions--1klCm";
export var limitWidthOnLargeScreens = "TrustedBy-module--limitWidthOnLargeScreens--aYKCQ";
export var score = "TrustedBy-module--score--njBjN";
export var secondRow = "TrustedBy-module--secondRow---oEcE";
export var stars = "TrustedBy-module--stars--x8lHr";
export var title = "TrustedBy-module--title--MSJdu";
export var trustedByWrapper = "TrustedBy-module--trustedByWrapper--MyWqD";
export var trustedByWrapper__noBottom = "TrustedBy-module--trustedByWrapper__noBottom--Qfb3n";